import { DownloadIcon } from "@radix-ui/react-icons";
import { Tooltip } from "antd";

import { HeaderIconButton } from "./AdminPage.styles";
import { exportCsvLabel, exportTableCsv, ITableCsvExport } from "./tableCsv";

interface IExportCsvButtonProps<T> {
  exportCsv: ITableCsvExport<T>;
  /** True while the table is refreshing — nothing to export until it settles. */
  disabled?: boolean;
}

/**
 * The CSV export as a header icon, beside Refresh (it used to be a text
 * button in the pagination footer). Same helper, same filename, same rows —
 * only the spot changed. The tooltip carries the row count the old button
 * showed, and says "this page" when the table is server-paginated. Disabled
 * with no rows or while the table refreshes.
 */
export function ExportCsvButton<T>({
  exportCsv,
  disabled = false,
}: IExportCsvButtonProps<T>) {
  const rowCount = exportCsv.rows.length;
  const isDisabled = disabled || rowCount === 0;

  return (
    <Tooltip title={exportCsvLabel(exportCsv)} placement="top">
      <HeaderIconButton
        type="button"
        aria-label="Export CSV"
        disabled={isDisabled}
        onClick={() => exportTableCsv(exportCsv)}
        data-testid="table-export-csv"
      >
        <DownloadIcon aria-hidden />
      </HeaderIconButton>
    </Tooltip>
  );
}
